var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _g6, _path12, _path13, _g7, _path14, _path15, _g8, _path16, _g9, _path17, _path18, _g10, _path19, _path20, _g11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 420,
    height: 419
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5833 0H459.417V418.833H40.5833V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 420,
    height: 419
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 0C134.344 0 40.5833 93.7604 40.5833 209.417C40.5833 325.073 134.344 418.833 250 418.833C365.656 418.833 459.417 325.073 459.417 209.417C459.417 93.7604 365.656 0 250 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5833 0H459.417V418.833H40.5833V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 360,
    width: 290,
    height: 140
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 360.438H394.667V500H105.5V360.438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 360,
    width: 290,
    height: 140
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250 500L394.5 360.438H105.5L250 500Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.5 360.438H394.911V499.724H105.5V360.438Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 11,
    width: 400,
    height: 400
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3438 11.651H449.656V410.964H50.3438V11.651Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 11,
    width: 400,
    height: 400
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250 11.651C139.734 11.651 50.3438 101.042 50.3438 211.307C50.3438 321.573 139.734 410.964 250 410.964C360.266 410.964 449.656 321.573 449.656 211.307C449.656 101.042 360.266 11.651 250 11.651Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3438 11.651H449.656V410.964H50.3438V11.651Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 355,
    width: 276,
    height: 135
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.234 355.292H388V489.333H112.234V355.292Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 355,
    width: 276,
    height: 134
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250 488.349L387.766 355.292H112.234L250 488.349Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.234 355.292H388.156V488.089H112.234V355.292Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 26,
    width: 372,
    height: 371
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7031 26.0104H435.297V396.604H64.7031V26.0104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 26,
    width: 372,
    height: 371
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250 26.0104C147.661 26.0104 64.7031 108.969 64.7031 211.307C64.7031 313.646 147.661 396.604 250 396.604C352.339 396.604 435.297 313.646 435.297 211.307C435.297 108.969 352.339 26.0104 250 26.0104Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7031 26.0104H435.297V396.604H64.7031V26.0104Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 165,
    width: 159,
    height: 92
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76 165.958H234.667V256.958H76V165.958Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.307 166.349C124.786 166.349 96.7031 180.344 78.25 204.74C75.375 208.536 75.375 213.844 78.25 217.641C96.7031 242.037 124.786 256.031 155.307 256.031C185.823 256.031 213.911 242.037 232.359 217.646C235.24 213.844 235.24 208.542 232.365 204.745C213.911 180.344 185.823 166.349 155.307 166.349ZM223.958 211.208C207.521 232.943 182.495 245.412 155.307 245.412C128.12 245.412 103.094 232.943 86.6563 211.177C103.094 189.438 128.12 176.969 155.307 176.969C182.495 176.969 207.521 189.438 223.958 211.177C223.958 211.177 223.958 211.203 223.958 211.208Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 179,
    width: 53,
    height: 53
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.536 179.438H211.932V231.833H159.536V179.438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 179,
    width: 53,
    height: 53
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.734 179.438C171.266 179.438 159.536 191.167 159.536 205.635C159.536 220.104 171.266 231.833 185.734 231.833C200.203 231.833 211.932 220.104 211.932 205.635C211.932 191.167 200.203 179.438 185.734 179.438Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.536 179.438H211.932V231.833H159.536V179.438Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 190,
    width: 20,
    height: 21
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169.401 190.854H188.849V210.307H169.401V190.854Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 190,
    width: 20,
    height: 21
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.125 190.854C173.755 190.854 169.401 195.208 169.401 200.583C169.401 205.953 173.755 210.307 179.125 210.307C184.495 210.307 188.849 205.953 188.849 200.583C188.849 195.208 184.495 190.854 179.125 190.854Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.401 190.854H188.849V210.307H169.401V190.854Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 264,
    y: 165,
    width: 160,
    height: 92
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M264.026 165.958H424V256.958H264.026V165.958Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.761 166.349C313.245 166.349 285.156 180.344 266.708 204.74C263.828 208.536 263.828 213.844 266.703 217.641C285.156 242.037 313.245 256.031 343.761 256.031C374.281 256.031 402.365 242.037 420.818 217.646C423.693 213.844 423.693 208.542 420.818 204.745C402.365 180.344 374.281 166.349 343.761 166.349ZM412.412 211.208C395.974 232.943 370.948 245.412 343.761 245.412C316.573 245.412 291.547 232.943 275.109 211.177C291.547 189.438 316.573 176.969 343.761 176.969C370.948 176.969 395.974 189.438 412.412 211.177C412.412 211.177 412.412 211.203 412.412 211.208Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 347,
    y: 179,
    width: 54,
    height: 53
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M347.995 179.438H400.391V231.833H347.995V179.438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 347,
    y: 179,
    width: 54,
    height: 53
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M374.193 179.438C359.724 179.438 347.995 191.167 347.995 205.635C347.995 220.104 359.724 231.833 374.193 231.833C388.662 231.833 400.391 220.104 400.391 205.635C400.391 191.167 388.662 179.438 374.193 179.438Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.995 179.438H400.391V231.833H347.995V179.438Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 357,
    y: 190,
    width: 21,
    height: 21
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M357.854 190.854H377.307V210.307H357.854V190.854Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_354_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_354_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 357,
    y: 190,
    width: 21,
    height: 21
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M367.578 190.854C362.208 190.854 357.854 195.208 357.854 200.583C357.854 205.953 362.208 210.307 367.578 210.307C372.953 210.307 377.307 205.953 377.307 200.583C377.307 195.208 372.953 190.854 367.578 190.854Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_354_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.854 190.854H377.307V210.307H357.854V190.854Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_354_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEor);
export default __webpack_public_path__ + "static/media/eor.33c21c2c275f94c7cb03eef1b0e14c77.svg";
export { ForwardRef as ReactComponent };